<span class="text-center cursor-pointer">
    <app-log-icon ngbTooltip="{{ tooltipText }}" placement="left" container="body">
    </app-log-icon>
</span>